'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getRoot = function getRoot(state) {
  return state.auth;
};

var didDetectAuth = exports.didDetectAuth = function didDetectAuth(state) {
  return getRoot(state).get('didDetectAuth');
};
var hasNewPortalAuth = exports.hasNewPortalAuth = function hasNewPortalAuth(state) {
  return getRoot(state).get('hasNewPortalAuth');
};
var isAuthenticated = exports.isAuthenticated = function isAuthenticated(state) {
  return !!hasNewPortalAuth(state);
};
var didAuthenticationFail = exports.didAuthenticationFail = function didAuthenticationFail(state) {
  return hasNewPortalAuth(state) === false;
};